// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"42b9cccf","455":"78a672f0"}[chunkId] + ".chunk.js";
};